// extracted by mini-css-extract-plugin
export default {"program-page":"Program_program-page__p8FyJ","navigation-dot-wrapper":"Program_navigation-dot-wrapper__RpfdM","navigation-dot":"Program_navigation-dot__Y2EhR"};